module.exports = __webpack_public_path__ + "static/media/circle-cloud-1.0b9f3e58.png";